import { cx } from '../../utils/cx';
import { Skeleton } from '../Skeleton/Skeleton';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden';
import { Thumbnail } from '../Thumbnail/Thumbnail';
import s from './LinkCard.module.css';

export type LinkCardProps = {
  loading?: boolean;
  title?: string | null;
  siteName?: string | null;
  imageUrl?: string | null;
  faviconUrl?: string | null;
  /** Shown under the title, e.g. a formatted price. */
  meta?: string | null;
  /** When the store blocked us: a friendly note replaces the title (doc 10). */
  unavailableNote?: string | null;
  className?: string;
};

/** A link preview: thumbnail, title, site name + favicon. */
export function LinkCard({
  loading,
  title,
  siteName,
  imageUrl,
  faviconUrl,
  meta,
  unavailableNote,
  className,
}: LinkCardProps) {
  if (loading) {
    return (
      <div className={cx(s.card, className)} role="status" aria-busy="true">
        <VisuallyHidden>Loading link preview</VisuallyHidden>
        <Skeleton.Rect width="var(--gg-size-thumb-md)" height="var(--gg-size-thumb-md)" />
        <span className={s.text}>
          <Skeleton.Text lines={2} />
          <Skeleton.Rect width="40%" height="0.7em" radius="var(--gg-radius-full)" />
        </span>
      </div>
    );
  }
  return (
    <div className={cx(s.card, className)}>
      <Thumbnail src={imageUrl} size="md" />
      <span className={s.text}>
        <span className={s.title}>{unavailableNote ?? title}</span>
        {meta ? <span className={s.meta}>{meta}</span> : null}
        {siteName ? (
          <span className={s.site}>
            {faviconUrl ? (
              <img
                src={faviconUrl}
                alt=""
                className={s.favicon}
                referrerPolicy="no-referrer"
                // Most sites have no /favicon.ico; a broken glyph is worse than none.
                onError={(event) => {
                  event.currentTarget.hidden = true;
                }}
              />
            ) : null}
            {siteName}
          </span>
        ) : null}
      </span>
    </div>
  );
}
